import styled from 'styled-components'
import * as All from '../BaseStyles'

export const ComponentsDiv = styled(All.ComponentsDiv)`
    top: 0rem;
    bottom: 0rem;
    left: 0rem;
    right: 0rem;
    overflow: auto;
`